<template>
  <v-app>
    <v-layout>
      <ServerMaintenance v-model="serverMaintenance" />
      <AppUpdate />
      <AuthView>
        <NavigationView />
        <EnvironmentIndicator />
        <v-main :data-page="route.name">
          <RouterView :key="route.fullPath" />
        </v-main>
      </AuthView>
      <component
        v-if="contextMenu"
        :is="contextMenu.component"
        v-bind="contextMenu.props"
        v-on="contextMenu?.handlers ?? {}" />
      <component
        v-if="dialog"
        :is="dialog.component"
        v-bind="dialog.props"
        v-on="dialog?.handlers ?? {}" />
    </v-layout>
    <MobileEmployeeNavigation v-if="userStore.userExists && isEmployeeOnly()" />
    <AppNotification />
  </v-app>
</template>

<script setup lang="ts">
import AuthView from "./AuthView.vue";
import { RouterView, useRoute } from "vue-router";
import NavigationView from "@/components/navigation/NavigationView.vue";
import EnvironmentIndicator from "./EnvironmentIndicator.vue";
import AppUpdate from "./AppUpdate.vue";
import AppNotification from "./AppNotification.vue";
import * as appInfo from "@/lib/appInfo";
import useContextMenu from "@/composables/useContextMenu";
import useDialog from "@/composables/useDialog";
import ServerMaintenance from "./ServerMaintenance.vue";
import { useAppStatusStore } from "@/stores/appStatus.store";
import { useUserStore } from "@/stores/user.store";
import { isEmployeeOnly } from "@/auth/auth.roles";
import { ref } from "vue";
import logger from "@/lib/logger";
import MobileEmployeeNavigation from "@/components/navigation/MobileEmployeeNavigation.vue";

const { contextMenu } = useContextMenu();
const { dialog } = useDialog();
const route = useRoute();
const appStatusStore = useAppStatusStore();
const userStore = useUserStore();
const serverMaintenance = ref(false);
appStatusStore.$subscribe((_mutation, state) => {
  serverMaintenance.value = state.serverMaintenance;
});
  
const versionString = `Version: ${appInfo.getAppVersion()}
• Built: ${appInfo.getBuildDate()}
• Build: ${appInfo.getBuildNumber()}
• Hash: ${appInfo.getCommitHash()}`;
logger.info(versionString);
</script>

<style lang="scss">
header {
  line-height: 1.5;
  max-height: 100vh;
}
</style>
